
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const FlagIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M20 15.25C20 11.2459 23.2459 8 27.25 8H70.7317C75.1989 8 77.625 13.2241 74.7429 16.6372L60.2172 33.8387C60.1385 33.9319 60.1385 34.0681 60.2172 34.1613L74.7429 51.3628C77.625 54.7759 75.1989 60 70.7317 60H27V84.5C27 86.433 25.433 88 23.5 88C21.567 88 20 86.433 20 84.5V15.25ZM27 53H66.9635L54.869 38.6776C52.5879 35.9763 52.5879 32.0237 54.869 29.3224L66.9635 15H27.25C27.1119 15 27 15.1119 27 15.25V53Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.5 15.25C23.5 13.1789 25.1789 11.5 27.25 11.5H70.7317C72.2208 11.5 73.0295 13.2414 72.0688 14.3791L57.5431 31.5806C56.3632 32.9778 56.3632 35.0222 57.5431 36.4194L72.0688 53.6209C73.0295 54.7586 72.2208 56.5 70.7317 56.5H27.25C25.1789 56.5 23.5 54.8211 23.5 52.75V15.25Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M20 15.25C20 11.2459 23.2459 8 27.25 8H70.7317C75.1989 8 77.625 13.2241 74.7429 16.6372L60.2172 33.8387C60.1385 33.9319 60.1385 34.0681 60.2172 34.1613L74.7429 51.3628C77.625 54.7759 75.1989 60 70.7317 60H27V84.5C27 86.433 25.433 88 23.5 88C21.567 88 20 86.433 20 84.5V15.25ZM27 53H66.9635L54.869 38.6776C52.5879 35.9763 52.5879 32.0237 54.869 29.3224L66.9635 15H27.25C27.1119 15 27 15.1119 27 15.25V53Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.5 15.25C23.5 13.1789 25.1789 11.5 27.25 11.5H70.7317C72.2208 11.5 73.0295 13.2414 72.0688 14.3791L57.5431 31.5806C56.3632 32.9778 56.3632 35.0222 57.5431 36.4194L72.0688 53.6209C73.0295 54.7586 72.2208 56.5 70.7317 56.5H27.25C25.1789 56.5 23.5 54.8211 23.5 52.75V15.25Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
